<header class="flex background-gradient py-5">
  <div class="mx-auto">
    <img src="assets/img/motorola-logo.svg" alt="Motorola Branding" class="motorola-branding">
  </div>
</header>

<main class="home-body m-auto">
  <div class="mx-5">
    <img src="assets/img/moto-ai-beta.svg" alt="Moto AI Beta">

    <div *ngIf="!isUnsubscribeSuccessful; else unsubscribe_successful">
      <div class="my-6">
        <h1 class="unsubscribe-title font-bold mb-4" [translate]="'app.unsubscribe.unsubscribeTitle'"></h1>
        <p class="unsubscribe-confirmation" [translate]="'app.unsubscribe.unsubscribeAgreement'"></p>
      </div>
      <button pButton
              [label]="'app.unsubscribe.unsubscribeButton' | translate"
              class="button unsubscribe-button"
              type="submit"
              (click)="unsubscribeUser()"
      ></button>
    </div>

    <ng-template #unsubscribe_successful>
      <div class="my-6">
        <h1 class="unsubscribe-title font-bold mb-4" [translate]="'app.unsubscribe.unsubscribeSuccessful'"></h1>
        <p class="unsubscribe-confirmation" [translate]="'app.unsubscribe.unsubscribeConfirmation'"></p>
      </div>
    </ng-template>
  </div>
</main>
